import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { DefaultRangeSliders } from "../../../../Constant";
import {DefaultRangeSliderForm} from "./DefaultRangeSliderForm"

const DefaultRangeSlider = () => {
    
  return (
    <Col lg="6">
      <Card>
        <CommonCardHeader title={DefaultRangeSliders} />
        <CardBody>
        <DefaultRangeSliderForm />
        </CardBody>
      </Card>
    </Col>
  );
};

export default DefaultRangeSlider;
